export default __webpack_public_path__ + "static/media/widget-bg-2.bb9466a6.png";